import { render, staticRenderFns } from "./DetailGift.vue?vue&type=template&id=75685ca2&scoped=true"
import script from "./DetailGift.vue?vue&type=script&lang=js"
export * from "./DetailGift.vue?vue&type=script&lang=js"
import style0 from "./DetailGift.vue?vue&type=style&index=0&id=75685ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75685ca2",
  null
  
)

export default component.exports